import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ColIdEnum } from 'src/app/services/reports.service';
import { TooltipService } from 'src/app/services/tooltip.service';

@Component({
  selector: 'cell-tooltips',
  template: `<div class="cell-values">
    <span
      class="cell-value"
      (mouseenter)="displayTooltip($event.target, i)"
      (mouseleave)="hideTooltip()"
      *ngFor="let value of values; let i = index"
    >
      <span *ngIf="value">{{ value.code }}</span>
    </span>
  </div>`,
  styles: [],
})
export class CellTooltipsComponent implements ICellRendererAngularComp {
  public values: any;
  private colId: string;

  /**
   * Maps columns to their API response property.
   */
  private apiPropertyMapping = {
    [ColIdEnum.mvrSvcCodes]: 'svcDetail',
    [ColIdEnum.mvrLicenseClass]: 'licenceClassDetail',
    [ColIdEnum.endorsements]: 'licenceEndorsementsDetail',
    [ColIdEnum.licenceType]: 'licenceTypeDetail',
    [ColIdEnum.cardStatus]: 'cardStatus',
    [ColIdEnum.mvrStatus]: 'mvrStatusDetail',
  };

  /**
   * Creates a new instance of CellTooltipsComponent
   */
  constructor(private tooltipService: TooltipService) {}

  /**
   * Executes when the grid initialises
   */
  agInit(params: ICellRendererParams) {
    if (!params.value) {
      return;
    }

    this.colId = params.colDef.colId;
    this.values = params.data[this.apiPropertyMapping[this.colId]];
  }

  /**
   * Displays the category tooltip with the correct content.
   */
  public displayTooltip(targetElement: any, index: number): void {
    const content = this.tooltipService.buildData(this.colId, this.values[index]);

    if (content) {
      this.tooltipService.setContent(content);
      this.tooltipService.displayRelativeTo(targetElement);
    }
  }

  /**
   * Hides the category tooltip.
   */
  public hideTooltip(): void {
    this.tooltipService.hide();
  }

  /**
   * Executed when the component is refreshed.
   */
  public refresh(): boolean {
    return false;
  }
}
